import { render, staticRenderFns } from "./CommunicationTrackingView.vue?vue&type=template&id=7b72b742&scoped=true&"
import script from "./CommunicationTrackingView.vue?vue&type=script&lang=js&"
export * from "./CommunicationTrackingView.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationTrackingView.vue?vue&type=style&index=0&id=7b72b742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72b742",
  null
  
)

export default component.exports